import { EscalationHistory, EscalationHistoryEvent, EscalationInterface, LocationVarKey } from "@swivl-mono/types";
import { Button, ButtonSize } from "@swivl-mono/ui";
import { DateTime } from "luxon";

import { DataCardLocation } from "../../../../Components/DataCards/DataCard.Location";
import EscalationsModel from "../../../../Models/Escalations/Escalations.Model";
import { Member } from "../../../../Models/Member/Member.Current";
import MembersModel from "../../../../Models/Member/Members.Model";
import { Subscription } from "../../../../Models/Subscription/Subscription.Current";
import "./EscalationHistoryDetails.scss";

interface Props {
  escalation: EscalationInterface;
}
// CREATED = 🤖 Bot Initiated Escalation
// AGENT_INITIATED = 👩‍💻 Agent Initiated Escalation
// AVAILABLE_AGENTS_LOOKED_UP =  🔍 Searched Available Agents
// ASSIGNED_TO_AGENT =  ➡️ Assigned to {Agent Name}
// AGENT_ACCEPTED =  💬 Accepted by {Agent Name}
// AGENT_REJECT =  🙅 Rejected by {Agent Name}
// AGENT_MISSED = 🙈 Missed by {Agent Name}
// CONVERSATION_ENDED = ✅ Conversation Ended by {Agent Name}
// TIMED_OUT =  💤 No Agents Accepted
// NO_AGENT_AVAILABLE = 🚫 No Agents Available
// OUTSIDE_HOURS =  ⏰ Outside Hours
function iconAndTextForHistoryEvent(event: EscalationHistory, hasAttempted: boolean) {
  const agent = event?.member ? event.member.agentName : "Unknown";
  switch (event.event) {
    case EscalationHistoryEvent.CREATED:
      return { icon: "🤖", text: <>Bot Initiated Escalation</> };
    case EscalationHistoryEvent.AGENT_INITIATED:
      return { icon: "👩‍💻", text: <>Agent Initiated Escalation</> };

    case EscalationHistoryEvent.AVAILABLE_AGENTS_LOOKED_UP:
      return { icon: "🔍", text: "Searched Available Agents" };
    case EscalationHistoryEvent.ASSIGNED_TO_AGENT:
      return {
        icon: "➡️",
        text: (
          <>
            Assigned to <b>{agent}</b>
          </>
        )
      };
    case EscalationHistoryEvent.AGENT_ACCEPTED:
      return {
        icon: "💬",
        text: (
          <>
            Accepted by <b>{agent}</b>
          </>
        )
      };
    case EscalationHistoryEvent.ACKNOWLEDGED:
      return {
        icon: "💬",
        text: (
          <>
            Acknowledged by <b>{agent}</b>
          </>
        )
      };
    case EscalationHistoryEvent.AGENT_REJECT:
      return {
        icon: "🙅",
        text: (
          <>
            Rejected by <b>{agent}</b>
          </>
        )
      };
    case EscalationHistoryEvent.AGENT_MISSED:
      return {
        icon: "🙈",
        text: (
          <>
            Missed by <b>{agent}</b>
          </>
        )
      };
    case EscalationHistoryEvent.CONVERSATION_ENDED:
      if (!agent || agent === "Unknown" || agent.length == 0) {
        return { icon: "✅", text: <>Conversation Ended</> };
      }
      return {
        icon: "✅",
        text: (
          <>
            Conversation Ended by <b>{agent}</b>
          </>
        )
      };
    case EscalationHistoryEvent.TIMED_OUT:
      return { icon: "💤", text: "No Agents Accepted" };
    case EscalationHistoryEvent.NO_AGENT_AVAILABLE:
      if (hasAttempted) {
        return { icon: "⚠️", text: "Escalation Not Accepted" };
      }
      return { icon: "🚫", text: "No Agent Available" };
    case EscalationHistoryEvent.OUTSIDE_HOURS:
      return { icon: "⏰", text: "Outside Hours" };
    case EscalationHistoryEvent.CLOSED_BY_SYSTEM:
      return { icon: "🔐", text: "Automatically Closed" };
    default:
      return { icon: "❓", text: "Unknown Event" };
  }
  // AGENT_INITIATED = "agent initiated",
  // AVAILABLE_AGENTS_LOOKED_UP = "available agents looked up",
  // ASSIGNED_TO_AGENT = "assigned to agent",
  // AGENT_ACCEPTED = "agent accepted",
  // ACKNOWLEDGED = "acknowledged",
  // AGENT_REJECT = "agent reject",
  // CLOSED_BY_SYSTEM = "closed by system",
  // AGENT_MISSED = "agent missed",
  // CONVERSATION_ENDED = "conversation ended",
  // TIMED_OUT = "timed out",
  // NO_AGENT_AVAILABLE = "no agent available",
  // OUTSIDE_HOURS = "outside hours"
}

export function EscalationHistoryDetails(props: Props) {
  const { generatedSummaries } = EscalationsModel.useState((s) => s);
  const { membersMap } = MembersModel.useState((s) => s);
  const { escalation } = props;

  const history = escalation.history || [];
  const type = history.length && history[0].event === EscalationHistoryEvent.AGENT_INITIATED ? "Agent Initiated Escalation" : "Bot Escalation";
  if (history.length) {
  }
  var hasAttempted = false;
  const historyItems = history
    .filter((h) => h.event !== EscalationHistoryEvent.AVAILABLE_AGENTS_LOOKED_UP)
    .map((h, i) => {
      if (
        h.event === EscalationHistoryEvent.AGENT_ACCEPTED ||
        h.event === EscalationHistoryEvent.AGENT_REJECT ||
        h.event === EscalationHistoryEvent.AGENT_MISSED ||
        h.event === EscalationHistoryEvent.ASSIGNED_TO_AGENT
      ) {
        hasAttempted = true;
      }
      const memberId = h.memberId || h.member?.id || null;
      const member = membersMap?.[memberId || -1];
      const { icon, text } = iconAndTextForHistoryEvent({ ...h, member }, hasAttempted) as any;
      console.log("HISTORY EVENT", h, member, icon, text);
      return (
        <div className="historyItem" key={i}>
          <div className="icon">{icon}</div>
          <div className="event">{text}</div>
          <div className="createdAt">{DateTime.fromISO(h.date as any).toFormat("t")}</div>
        </div>
      );
    });

  const initialAgents = !escalation.initialMemberStatus ? null : (
    <div className="initialAgents">
      <h2>Available Agents</h2>
      {escalation.initialMemberStatus.available.length ? (
        escalation.initialMemberStatus.available.map((agent, i) => {
          return (
            <div className="agent" key={agent.id}>
              {agent.name}
            </div>
          );
        })
      ) : (
        <div className="agent noAgent">None</div>
      )}
      <h2>Unavailable Agents</h2>
      {escalation.initialMemberStatus.unavailable.length ? (
        escalation.initialMemberStatus.unavailable.map((agent, i) => {
          return (
            <div className="agent" key={agent.id}>
              {agent.name}
            </div>
          );
        })
      ) : (
        <div className="agent noAgent">None</div>
      )}
      {escalation.locationId && (
        <>
          <h2>Not allowed at location</h2>
          {escalation.initialMemberStatus.notAllowed?.length ? (
            escalation.initialMemberStatus.notAllowed.map((agent, i) => {
              return (
                <div className="agent" key={agent.id}>
                  {agent.name}
                </div>
              );
            })
          ) : (
            <div className="agent noAgent">None</div>
          )}
        </>
      )}
    </div>
  );

  const hasSummary = escalation.summary && escalation.summary.length > 0;
  const canSeeSummary = hasSummary || Subscription.featureEnabled(LocationVarKey.SubscriptionAdvancedEmbed) || Member.isSwivlStaff;
  const isLoadingSummary = generatedSummaries && generatedSummaries[escalation.id] && generatedSummaries[escalation.id] === "loading";

  return (
    <div className="EscalationHistoryDetails">
      <h1 className="text-3xl text-grey-800">{escalation.user?.name || "Unknown"}</h1>
      <div className={canSeeSummary ? "statsLine hasSummary" : "statsLine"}>
        {type} | {DateTime.fromISO(escalation.createdAt as any).toFormat("L/d/yy @ t")} |{" "}
        <a href={`/contact-center/conversations/user/${escalation.user?.id}`} target="_blank" rel="noopener noreferrer">
          Transcript
        </a>
      </div>
      {isLoadingSummary ? (
        <div className="summary flex justify-between">
          <h3>⚡️ Generating Conversation Summary </h3>

          <Button size={ButtonSize.SMALL} loading={true}>
            Generate
          </Button>
        </div>
      ) : canSeeSummary && hasSummary ? (
        <div className="summary">
          <h3>📖 Conversation Summary</h3>
          <div className="summaryText">{escalation.summary?.trim()}</div>
        </div>
      ) : (
        <div className="summary flex justify-between">
          <h3>⚡️ Conversation Summary </h3>
          <Button size={ButtonSize.SMALL} onClick={() => EscalationsModel.generateSummaryForEscalation(escalation)}>
            Generate
          </Button>
        </div>
      )}

      {escalation.locationId && (
        <DataCardLocation classNames={{ wrapper: "pl-0 pr-0" }} title="Location" locationId={escalation.locationId} size="compact" />
      )}

      <div className="historyItems">
        <div className="historyItemsHeader">
          <div className="event">Activity</div>
          <div className="createdAt">Timestamp</div>
        </div>
        <div className="historyItemsBody">
          {historyItems}
          <div className="dottedLine" />
        </div>
      </div>
      {initialAgents}
    </div>
  );
}
